var embedCard = {
    inline: false,
    group: 'block',
    selectable: true,
    attrs: {
        url: { default: '' },
        layout: { default: 'center' },
        width: { default: null },
        originalWidth: { default: null },
        originalHeight: { default: null },
    },
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function (dom) { return ({
                url: dom.getAttribute('data-card-url'),
                layout: dom.getAttribute('data-layout') || 'center',
                width: Number(dom.getAttribute('data-width')) || null,
                originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
            }); },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, url = _a.url, layout = _a.layout, width = _a.width, originalWidth = _a.originalWidth, originalHeight = _a.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
        };
        return ['div', attrs];
    },
};

export { embedCard };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/embed-card.js